import { ApplicationRoleCode } from '@kcftech/prometheus-client';
import styled from 'styled-components';
import { Lookup } from 'utils/types';

export const applicationRoleToName: Lookup<ApplicationRoleCode, string> = {
    [ApplicationRoleCode.User]: 'User',
    [ApplicationRoleCode.Sentry]: 'Sentry',
    [ApplicationRoleCode.Sales]: 'Sales',
    [ApplicationRoleCode.GlobalAdmin]: 'System Admin',
};

export const StyledCell = styled.div`
    & > * {
        flex-grow: unset;
    }
`;
